import { REQUEST_COUNT_UPDATED } from "../Constants";

export default function(state = 0, action) {
    switch (action.type) {
    case REQUEST_COUNT_UPDATED:
        if (action.payload) {
            return state + 1;
        }

        const newState = state - 1;

        return newState < 0 ? 0 : newState;
    }
    return state;
}